import { FormSection, FormRow, BigFormRow } from 'framework/ui/layout';
import { DateInput, EnumDropdown, Checkbox } from 'framework/form';
import { OPPORTUNITY_PROJECT_TYPE } from 'domain/shared/presale';
import RequiredResourcesListInput from 'domain/sales/opportunity/presale/output/shared/input/RequiredResourcesListInput';
import RequiredResourcesInputTemplate from 'domain/sales/opportunity/presale/output/shared/input/RequiredResourcesInputTemplate';

const PresaleOutputInputForm = ({ inputErrors }: { inputErrors?: Dictionary<any> }) => {
  return (
    <>
      <FormSection title="Last Presale Output Info">
        <FormRow>
          <DateInput
            source="expectedProjectStart"
            label="Expected Start"
            helpText="Should be in the future. Please, mark as valid before submit!"
          />
          <Checkbox source="isValidExpectedProjectStart" label="Valid?" />
        </FormRow>
        <FormRow>
          <EnumDropdown
            options={OPPORTUNITY_PROJECT_TYPE}
            source="projectType"
            label="Project Type"
            placeholder="Select..."
            helpText="Please, mark as valid before submit!"
          />
          <Checkbox source="isValidProjectType" label="Valid?" />
        </FormRow>
      </FormSection>
      <FormSection title="Team structure">
        <BigFormRow>
          <RequiredResourcesListInput
            source="requiredResources"
            addText="Add Member"
            maxFields={30}
            inputTemplate={RequiredResourcesInputTemplate}
            helpText="Please, mark as valid before submit!"
          />
        </BigFormRow>
        <FormRow>
          <Checkbox source="isValidRequiredResources" label="Valid?" />
        </FormRow>
      </FormSection>
    </>
  );
};

export default PresaleOutputInputForm;
